<!-- 大用户总览分析 -->
<template>
  <div class="mainWarp">
    <div class="img-title">
      <img src="/iconImg/h_title_bg.png" />
      <span class="DataTitle">大用户总览分析</span>
    </div>
    <div class="content">
      <div class="chart-container">
        <div class="chart-top">
          <div class="top-chart">
            <span class="top-chart-font">大用户总数</span>
            <span class="top-chart-font2">{{ proportionData[0].value }}</span>
          </div>
          <div class="left-chart">
            <div ref="bigUserChart" class="with-corner-images" style="height: 150px;"></div>
          </div>
        </div>
        <div style="width: 100%; padding: 0 30px;">
          <img width="100%" src="~@/assets/bigusers/largeScreen/userWaterMeterLine.png" />
        </div>
        <div class="chart-bottom">
          <div ref="proportionChart" class="proportion-chart" style="height: 150px;"></div>
          <div class="proportion-right">
            <div class="proportion-right-box1">
              <img src="~@/assets/bigusers/largeScreen/proportionIcon1.png" />
              <span class="proportion-span1">大用户</span>
              <span class="proportion-span2 clickable-number" @click="handleNumberClick">{{ proportionData[0].value }}</span>
            </div>
            <div class="proportion-right-box2">
              <img src="~@/assets/bigusers/largeScreen/proportionIcon2.png" />
              <span class="proportion-span1">总用户数</span>
              <span class="proportion-span2 clickable-number" @click="handleNumberClick">{{ proportionData[1].value }}</span>
            </div>
          </div>
        </div>

      </div>
      <!-- 底部样式 -->
      <div class="top"></div>
      <div class="middle"></div>
      <div class="bottom"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  name: 'LeftUserAnalysis',
  data () {
    return {
      userAnalysisUrl: '/smart-water-major-users/major/users/user/user/count/ifLargeUsers',
      queryCountTypeUrl: '/smart-water-major-users/major/users/user/count/belongingarea', //查询大用户类型数量
      bigUserNumberTop: [13, 46, 79, 112],
      bigUserPercentageTop: [16, 49, 81, 115],
      typeConut: { 1: 0, 2: 0, 3: 0, 4: 0 },
      bigUserData: [
        { value: 0, name: '居民用水', percentage: '0%' },
        { value: 0, name: '非居民用水', percentage: '0%' },
        { value: 0, name: '特种用水', percentage: '0%' },
        { value: 0, name: '其他', percentage: '0%' },
      ],
      proportionData: [
        { value: 0, name: '大用户', percentage: '0%' },
        { value: 0, name: '总用户数', percentage: '0%' },
      ]
    };
  },
  mounted () {
    this.initChart();
  },
  methods: {
    initChart () {
      this.getUserAnalysis();
      this.getCountType();
    },
    getCountType () {
      this.$http.get(this.queryCountTypeUrl).then((res) => {

        if (res.data.length == 0) {
          this.typeConut = { 1: 0, 2: 0, 3: 0, 4: 0 }
          return;
        }
        res.data.forEach(element => {
          this.typeConut[element.waterType] = Number(element.waterTypeCount);
        });
        // 计算总数
        const totalCount = Object.values(this.typeConut).reduce((sum, count) => sum + count, 0);
        // 计算每种类型的百分比
        this.bigUserData = [
          {
            value: this.typeConut[1],
            name: '居民用水',
            percentage: totalCount > 0 ? Math.round((this.typeConut[1] / totalCount) * 100) + '%' : '0%'
          },
          {
            value: this.typeConut[2],
            name: '非居民用水',
            percentage: totalCount > 0 ? Math.round((this.typeConut[2] / totalCount) * 100) + '%' : '0%'
          },
          {
            value: this.typeConut[3],
            name: '特种用水',
            percentage: totalCount > 0 ? Math.round((this.typeConut[3] / totalCount) * 100) + '%' : '0%'
          },
          {
            value: this.typeConut[4],
            name: '其他',
            percentage: totalCount > 0 ? Math.round((this.typeConut[4] / totalCount) * 100) + '%' : '0%'
          },
        ]
        // 重新绘制图表
        this.createBigUserChart();
      })
    },
    getUserAnalysis () {
      this.$http.get(this.userAnalysisUrl).then((res) => {
        const bigUserCount = res.data.bigUser;
        const totalUserCount = res.data.all;
        const normalUserCount = totalUserCount - bigUserCount; // 普通用户数

        // 动态计算百分比
        const bigUserPercentage = totalUserCount > 0 ? Math.round((bigUserCount / totalUserCount) * 100) : 0;
        const normalUserPercentage = 100 - bigUserPercentage;

        this.proportionData = [
          { value: bigUserCount, name: '大用户', percentage: bigUserPercentage + '%' },
          { value: totalUserCount, name: '总用户数', percentage: normalUserPercentage + '%' },
        ]
        this.createProportionChart();
      })
    },

    createBigUserChart () {
      const chartDom = this.$refs.bigUserChart;
      const myChart = echarts.init(chartDom);
      let bigUsergraphic = []
      //循环获取大用户数量和百分比来制定样式
      this.bigUserData.forEach((item, key) => {
        bigUsergraphic.push(
          {
            type: 'text',
            right: 95,
            top: this.bigUserNumberTop[key],
            style: {
              text: item.value,
              fontSize: 20,
              fontWeight: 'bold',
              fill: '#24a1e1',
              cursor: 'pointer'
            },
            onclick: () => {
              this.handleNumberClick();
            }
          }
        )
        bigUsergraphic.push(
          {
            type: 'text',
            right: 42,
            top: this.bigUserPercentageTop[key],
            style: {
              text: item.percentage,
              fontSize: 16,
              fontWeight: 'bold',
              fill: '#addcf2'
            }
          }
        )
      })
      //创建Option对象
      let bigUserOption = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          icon: 'circle',
          y: 'center',     //可设定图例在上、下、居中
          orient: 'vertical',
          right: 150,
          itemGap: 18, // 增大行距，默认值是10
          textStyle: {  // 添加textStyle配置
            color: '#0cefed',
            fontSize: 15,    //设置字体大小
            fontWeight: 300
          },
        },
        graphic: bigUsergraphic,
        series: [
          {
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['20%', '50%'],  // 饼图中心位置向左移动
            avoidLabelOverlap: false,
            itemStyle: {
              color: function (params) {
                var colorList = ['#219efb', '#f1a007', '#630abe', '#00d5de'];
                return colorList[params.dataIndex];
              },
              borderWidth: 0,
              shadowColor: 'rgba(28, 118, 174, 0.5)',
              shadowBlur: 30,
              shadowOffsetX: 0,
              shadowOffsetY: 0
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {

            },
            labelLine: {
              show: false
            },
            data: this.bigUserData
          },

        ]
      }
      myChart.setOption(bigUserOption);
      
      // 添加点击事件监听，点击饼图数据项时跳转
      myChart.on('click', (params) => {
        if (params.componentType === 'series' && params.seriesType === 'pie') {
          this.handleNumberClick();
        }
      });
      
      // 响应式调整
      window.addEventListener('resize', () => {
        myChart.resize();
      });
    },
    createProportionChart () {
      const chartDom = this.$refs.proportionChart;
      const myChart = echarts.init(chartDom);
      //创建Option对象
      let bigUserOption = {
        tooltip: {
          trigger: 'none'
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['54%', '50%'],  // 饼图中心位置向左移动
            avoidLabelOverlap: false,
            itemStyle: {
              color: function (params) {
                var colorList = ['#23cbfc', '#04092a'];
                return colorList[params.dataIndex];
              },
              borderWidth: 0,
              shadowColor: 'rgba(28, 118, 174, 1)',
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowOffsetY: 0
            },
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: this.proportionData,
            label: {//饼图中间文字设置
              normal: {
                show: true,
                position: 'center',
                color: '#23cbfc',
                fontWeight: 'bold',
                formatter: this.proportionData[0].percentage,
                fontSize: 18,
              },
              emphasis: {//中间文字显示
                show: true,
              }
            },
          }
        ]
      }
      myChart.setOption(bigUserOption);
      
      // 添加点击事件监听，点击饼图数据项时跳转
      myChart.on('click', (params) => {
        if (params.componentType === 'series' && params.seriesType === 'pie') {
          this.handleNumberClick();
        }
      });
      
      // 响应式调整
      window.addEventListener('resize', () => {
        myChart.resize();
      });
    },
    // 处理数字点击跳转
    handleNumberClick() {
      this.$router.push('/bigusers/workbench/userControl/AllUserPage');
    }
  },

  beforeDestroy () {
    // 组件销毁时移除事件监听
    window.removeEventListener('resize', () => { });
  }
};
</script>

<style lang="less" scoped>
.mainWarp {
  height: 384.5px;
  width: 412px;
  position: relative;
  font-family: MicrosoftYaHei;


  .content {
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    /* 添加相对定位 */
  }

  .chart-container {
    position: absolute;
    top: 25px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    /* 确保在底层 */
  }

  .top {
    flex: 0 0 60px;
    background: url(~@/assets/bigusers/largeScreen/topBox.png) no-repeat;
    background-size: 100% 100%;
    /* 完全填充 */
  }

  .middle {
    flex: 0 0 70%;
    background: url(~@/assets/bigusers/largeScreen/middleBox.png) repeat;
    background-size: 100% auto;
    /* 水平拉伸，垂直平铺 */
  }

  .bottom {
    flex: 0 0 60px;
    background: url(~@/assets/bigusers/largeScreen/bottomBox.png) no-repeat;
    background-size: 100% 100%;
    /* 完全填充 */
  }

  .img-title {
    position: absolute;
    top: -20px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #00ebee;
    font-weight: 600;
    line-height: 30px;
    z-index: 1;
    /* 确保标题在最上层 */

    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }

    img {
      width: 264px;
      height: 35px;
    }
  }
}

.top-chart {
  text-align: center;
  margin-bottom: 10px;

  .top-chart-font {
    color: #0cefed;
    display: inline-block;
    margin-right: 15px;
    font-size: 15px;
    font-weight: 300;
  }

  .top-chart-font2 {
    color: #24a1e1;
    font-size: 20px;
    font-weight: bold;
  }
}

.left-chart {
  position: relative; // 添加相对定位，作为子元素定位基准
  width: 100%;
  height: 150px;

  >div[ref="pieChart"] {
    width: 100%; // 饼图占满整个父容器
    height: 100%;
    position: relative;
    z-index: 1; // 确保饼图在底层
  }
}


.with-corner-images {
  position: relative;
  /* 让伪元素基于此定位 */
}

/* 左上角图片 */
.with-corner-images::before {
  content: "";
  position: absolute;
  top: 0;
  left: 140px;
  width: 30px;
  /* 图片宽度 */
  height: 30px;
  /* 图片高度 */
  background-image: url('~@/assets/bigusers/largeScreen/leftUserWaterMeterTop.png');
  background-size: contain;
  /* 保持图片比例 */
  background-repeat: no-repeat;

  /* 确保图片在内容之上 */
}

/* 右下角图片 */
.with-corner-images::after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 20px;
  width: 30px;
  /* 图片宽度 */
  height: 30px;
  /* 图片高度 */
  background-image: url('~@/assets/bigusers/largeScreen/leftUserWaterMeterBottom.png');
  background-size: contain;
  /* 保持图片比例 */
  background-repeat: no-repeat;
  z-index: 1;
  /* 确保图片在内容之上 */
}

.chart-bottom {
  display: flex;
  /* 启用 Flex 布局 */
  align-items: center;
}

.proportion-chart {
  width: 150px;
  height: 150px;
  /* 与右侧高度一致 */
  flex-shrink: 0;
  /* 防止图表被压缩 */
}

.proportion-right {
  display: block;
  width: 262px;
  height: 150px;
  flex: 1;
  margin-right: 15px;

  .proportion-right-box1 {
    position: relative;
    /* 父容器设为相对定位 */
    height: 49px;
    width: 213px;
    background-image: url('~@/assets/bigusers/largeScreen/proportionBox.png');
    background-size: contain;
    background-repeat: no-repeat;
    margin: 10px 15px;
    margin-bottom: 20px;

  }

  .proportion-right-box2 {
    position: relative;
    /* 父容器设为相对定位 */
    height: 49px;
    width: 213px;
    background-image: url('~@/assets/bigusers/largeScreen/proportionBox.png');
    background-size: contain;
    background-repeat: no-repeat;
    margin: 10px 15px;

  }

  .proportion-right-box1,
  .proportion-right-box2 {
    display: flex;
    align-items: center;
    /* 确保图片和文字垂直居中 */
    gap: 8px;
    /* 控制间距 */
    padding-left: 10px;

    /* 调整左侧内边距 */
    img {
      width: 20px;
      height: 20px;
    }
  }


  .proportion-span1 {
    color: #00ebee;
    font-size: 15px;
    line-height: 1;
    /* 防止行高影响对齐 */
    font-weight: 300;
    display: inline-block;
    width: 80px;
  }

  .proportion-span2 {
    color: #24a1e1;
    font-size: 20px;
    font-weight: bold;
    line-height: 1;
    
    &.clickable-number {
      cursor: pointer;
      transition: all 0.3s;
      
      &:hover {
        color: #0cefed;
        text-shadow: 0 0 8px rgba(12, 239, 237, 0.6);
      }
    }
  }
}
</style>